import { ArrayField, Datagrid, NumberField, TextField } from "react-admin"
import { Stack, Typography, Button } from "@mui/material"

const BookingInfoComponent = () => {
  const fffBaseUrl = process.env.REACT_APP_FREE_FIBU_BASE_URL ? process.env.REACT_APP_FREE_FIBU_BASE_URL : 'http://localhost:10101/fff'

  return (
    <Stack width={"100%"} spacing={2} >
      <Typography variant="h6">Buchungsinfos:</Typography>
      <ArrayField source="bookingInfos" >
        <Datagrid bulkActionButtons={false} size="small" >
          <TextField source="bookingNumber" label="resources.invoices.bookingInfo.bookingNumber" sortable={false} />
          <TextField source="bookingPeriodName" label="resources.invoices.bookingInfo.bookingPeriodName" sortable={false} />
          <NumberField source="amount" options={{ style: 'currency', currency: 'EUR' }} label="resources.invoices.bookingInfo.amount" sortable={false} />
          <NumberField source="taxInPercent" options={{ style: 'percent'}} label="resources.invoices.bookingInfo.taxInPercent" sortable={false} />
          <TextField source="bookingText" label="resources.invoices.bookingInfo.bookingText" sortable={false} />
        </Datagrid>
      </ArrayField>
      <Button 
        sx={{maxWidth: "50%"}} 
        href={`${fffBaseUrl}/buchung?erfassungsmodusSchluessel=1210`} 
        variant='contained' 
        size='small'
      >
        Buchungen anzeigen
      </Button>
    </Stack>
  )
}

export default BookingInfoComponent